import React from 'react';
import ApprovalQueueContainer from '../../components/modules/Approvals/Queue';

const ApprovalQueue = () => {
  return <ApprovalQueueContainer />;
};

export default ApprovalQueue;
